import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ExternalVerificationRepository from '@/repositories/ExternalVerificationRepository';
import { CreateInsuranceVerificationRequest } from '@/types/externalVerification';
import { InsuranceVerification } from '@/types/insuranceVerification';

export const useCreateInsuranceVerificationFromExternal = (
  options?: MutationOptions<
    InsuranceVerification,
    AxiosError,
    { data: CreateInsuranceVerificationRequest }
  >
) => {
  const externalVerificationRepository = ExternalVerificationRepository();
  const { addMessage } = useContext(AppContext);

  return useMutation({
    mutationFn: ({ data }: { data: CreateInsuranceVerificationRequest }) =>
      externalVerificationRepository.createInsuranceVerification(data),
    onSuccess: () => {
      addMessage({ level: 'success', text: 'VOB saved successfully' });
    },
    ...options
  });
};

export default useCreateInsuranceVerificationFromExternal;
